import type { Phase } from '~hooks/useProjects/models';

import type { PhaseOptions } from './types';

// Copy an existing project's phases into a "these will be created as new
// records" state: assign fresh _temp_ ids so each phase stays uniquely
// identifiable (PhaseDrawer's edit / delete / set-primary handlers key off
// id), and PhaseSelection strips the _temp_ prefix back to '' before submit
// so the server treats them as new.
//
// Used by: ProjectDetailsV2 (user switches selected project in order form)
// and stripProjectIdsForCopy (Copy & Edit a project).
export function copyPhasesForNewProject(
  phases: readonly Pick<Phase, 'name' | 'code' | 'primary'>[],
): PhaseOptions[] {
  return phases.map((phase) => ({
    id: `_temp_${crypto.randomUUID()}`,
    name: phase.name,
    code: phase.code,
    primary: phase.primary,
  }));
}
